"use client"
import React from 'react';
import Image from "next/image";
import WarningIcon from "@/public/icons/warning-icon.svg";
import {SingleProductEnum} from "@/constants/commerce-enum";
import {Button} from "@/components/ui/button";
import ReportCommentFormModal from "@/components/global/modals/report-comment-form-modal";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import WizardFormAuth from "@/components/global/modals/wizard-auth-form-modal";
import {useAuthStore} from "@/store/auth/authStore";

function ReportCommentComponent({id , agent} : any) {

    const queryClient = new QueryClient()
    const {token} = useAuthStore((state) => state);

    if (!token) {
        return (
            <WizardFormAuth
                customButton={
                    agent === "desktop" ?
                        <Button variant={"none"} type={"button"}
                                className="text-red-500 font-medium text-sm gap-1 items-center flex">
                            <Image src={WarningIcon} alt={"WarningIcon"} title={"WarningIcon"}  width={24} height={24}/>
                            {SingleProductEnum.reportComment}
                        </Button>
                        : <Button variant={"none"} type={"button"}
                                  className="text-red-500 p-0 font-medium text-sm gap-1 items-center flex">
                            <Image src={WarningIcon} alt={"WarningIcon"} title={"WarningIcon"}  width={20} height={20}/>
                        </Button>
                }
            />
        )
    }

    return (
        <QueryClientProvider client={queryClient}>
            {
                token ?  (
                    <ReportCommentFormModal
                        modelId={id}
                        customButton={
                            agent === "desktop" ?
                                <Button variant={"none"} type={"button"}
                                        className="text-red-500 font-medium text-sm gap-1 items-center flex">
                                    <Image src={WarningIcon} alt={"WarningIcon"} title={"WarningIcon"} width={24} height={24}/>
                                    {SingleProductEnum.reportComment}
                                </Button>
                                : <Button variant={"none"} type={"button"}
                                          className="text-red-500 p-0 font-medium text-sm gap-1 items-center flex">
                                    <Image src={WarningIcon} alt={"WarningIcon"} title={"WarningIcon"} width={20} height={20}/>
                                </Button>
                        }
                    />
                ) : (
                    <WizardFormAuth
                        customButton={
                            agent === "desktop" ?
                                <Button variant={"none"} type={"button"}
                                        className="text-red-500 font-medium text-sm gap-1 items-center flex">
                                    <Image src={WarningIcon} alt={"WarningIcon"} title={"WarningIcon"} width={24} height={24}/>
                                    {SingleProductEnum.reportComment}
                                </Button>
                                : <Button variant={"none"} type={"button"}
                                          className="text-red-500 p-0 font-medium text-sm gap-1 items-center flex">
                                    <Image src={WarningIcon} alt={"WarningIcon"} width={20} height={20}/>
                                </Button>
                        }
                    />
                )
            }

        </QueryClientProvider>

    );
}

export default ReportCommentComponent;